import openai from "../brands/openai";
import deepseek from "../brands/deepseek";
import qwen from "../brands/qwen";
import gemini from "../brands/gemini";
export default { OPEN_AI: openai, DEEP_SEEK: deepseek, QWEN: qwen, GOOGLE_GEMINI: gemini };
